class GameFactModelDTO {

    constructor(gameFactModelData){
        if(!gameFactModelData)
            return

        const {_id, name, idName, provider, type} = gameFactModelData

        this._id = _id
        this.idName = idName
        this.name = name

        this.provider = provider

        this.type = new TypeDTO(type)
    }
}

class TypeDTO {

    constructor(typeData){
        if(!typeData)
            return

        const {category, name, values, format, maxOccurence, unit, selection, minRange, maxRange} = typeData

        this.name = name
        this.category = category
        this.format = format
        this.values = values
        this.selection = selection
        this.maxOccurence = maxOccurence
        this.unit = unit
        this.minRange = minRange
        this.maxRange = maxRange
    }
}

export default GameFactModelDTO